import type { AppConfig } from '../types'
import type { Action } from '../booking/state'
import { track } from '../analytics'
import { Icon } from '../icons'

/** 7.1 Choose a service (profile). Entirely config-driven; skips hidden profiles. */
export function ServiceStep({
  config,
  dispatch
}: {
  config: AppConfig
  dispatch: React.Dispatch<Action>
}) {
  const profiles = config.profiles.filter((p) => !p.hidden)
  const heading = config.copy?.serviceHeading || 'What would you like to be seen for?'
  const sub = config.copy?.serviceSub ?? 'Choose a service to get started.'

  return (
    <section className="service-step">
      <h1 className="step-heading">{heading}</h1>
      {sub && <p className="step-sub">{sub}</p>}

      <div className="card-grid services">
        {profiles.map((p, i) => (
          <button
            key={`${p.id}-${i}`}
            className={`choice-card${p.is_call_to_action ? ' cta' : ''}`}
            onClick={() => {
              track('select_profile', { profile: p.id, name: p.name })
              dispatch({ type: 'SELECT_PROFILE', profile: p })
            }}
          >
            <span className="icon-tile" aria-hidden>
              <Icon value={p.icon} size={26} />
            </span>
            <span className="title">
              {p.name}
              {p.name_line_2 ? ` ${p.name_line_2}` : ''}
            </span>
            {p.description && <span className="desc">{p.description}</span>}
          </button>
        ))}
      </div>
    </section>
  )
}
